/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/PDFGenerator.yaml

import { ScanbotPdfGeneratorImpl } from './impl';
import type { ImageInput, OcrConfiguration } from './types/base/customTypes';
import type { PdfConfiguration } from './types/core/pdf_generation/PdfConfigurationTypes';

/**
 * Entry point for all PDF generation features.
 */
export const ScanbotPdfGenerator = {
  /**
   * Creates a PDF from the provided images with the specified configuration.
   * @param {ImageInput[]} params.images - The list of images to be used for creating the PDF.
   * @param {PdfConfiguration} params.pdfConfiguration - The configuration for the generated PDF.
   * @param {OcrConfiguration} params.ocrConfiguration - The configuration for OCR processing.
   * @returns {Promise<string>} - The file uri pointing to the generated PDF file.
   */
  async generateFromImages(params: {
    images: ImageInput[];
    pdfConfiguration: PdfConfiguration;
    ocrConfiguration?: OcrConfiguration;
  }): Promise<string> {
    return ScanbotPdfGeneratorImpl.generateFromImages(params);
  },
  /**
   * Creates a PDF from the provided images with the specified configuration.
   * @param {string} params.documentUuid - The Uuid of the document to be used for creating the PDF.
   * @param {PdfConfiguration} params.pdfConfiguration - The configuration for the generated PDF.
   * @param {OcrConfiguration} params.ocrConfiguration - The configuration for OCR processing.
   * @returns {Promise<string>} - The file uri pointing to the generated PDF file.
   */
  async generateFromDocument(params: {
    documentUuid: string;
    pdfConfiguration: PdfConfiguration;
    ocrConfiguration?: OcrConfiguration;
  }): Promise<string> {
    return ScanbotPdfGeneratorImpl.generateFromDocument(params);
  },
};
